module.exports = __webpack_public_path__ + "static/media/left-gradient-cover.fd8bb145.svg";